import { Reducer } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export default (reducers: Reducer) => {
  const persistedReducers = persistReducer(
    {
      key: "sell.it",
      storage,
      whitelist: ["user"], // Persistir APENAS dados do usuário
      // Removido "sideMenuReducer" - não precisa persistir
    },
    reducers
  );
  return persistedReducers;
};
